module.exports = __webpack_public_path__ + "img/کارت-ویزیت-شیشه-ایی.8b706a34.png";